export function navigateTopLevel(target: string) {
  window.location.assign(target);
}
